window.addEventListener("load", function () {
  const swiper = new Swiper(".swiper", {
    slidesPerView: 1.5,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
    },
  });
});
